import { ProductTypeAssortment, ProductTypesFilter } from '@/types';
import { getParams } from '@/utils/params';
import { getCurrency } from '@/redux/core/getters/getCurrency';
import { StoreState } from '@/redux/types';
import { fetchFromDesignerService } from './fetchFromDesignerService';

export const fetchAssortment = (filter: ProductTypesFilter, getState: () => StoreState) => {
  const params: Record<string, string> = { shopId: getParams().contextId };

  if (filter.category) {
    params.category = filter.category;
  }
  if (filter.department) {
    params.department = filter.department;
  }
  if (filter.sizeGroup) {
    params.sizeGroup = filter.sizeGroup;
  }
  if (filter.appearanceGroup) {
    params.appearanceGroup = filter.appearanceGroup;
  }
  if (filter.brand) {
    params.brand = filter.brand;
  }
  if (filter.feature) {
    params.label = filter.feature;
  }
  if (filter.material) {
    params.material = filter.material;
  }
  if (filter.refinement) {
    params.refinement = filter.refinement;
  }
  if (filter.fit) {
    params.fit = filter.fit;
  }
  if (filter.style) {
    params.style = filter.style;
  }
  if (filter.neckline) {
    params.neckline = filter.neckline;
  }
  if (filter.sleeve) {
    params.sleeve = filter.sleeve;
  }
  if (filter.maxPrice) {
    params.maxPrice = filter.maxPrice;
    params.currency = getCurrency(getState()).isoCode;
  }

  return fetchFromDesignerService<ProductTypeAssortment>('assortment', params);
};
